// extracted by mini-css-extract-plugin
module.exports = {"home":"About_home__3W0eU","major":"About_major__wyPGt","title":"About_title__V6Ttq","text":"About_text__k2ihI","right":"About_right__1pWvS"};